import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Card, Divider, FormControlLabel, Grid, TextField, Typography } from '@mui/material';
import { useGetWorkbenchTypesQuery } from '~/api/v2/hooks';
import { modalOverflowBoxStyles } from '~/components/styles';
import { MAX_DESCRIPTION_LENGTH, workbenchNameRules } from '~/validation/workbenchSchema';
import { InstanceTypeField, WorkbenchGroupField } from '..';

const CreateWorkbenchForm = () => {
  const projectId = +useParams().projectid!;
  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext();
  const { data: typesData } = useGetWorkbenchTypesQuery({ projectId });
  const selectedWorkbenchGroup = watch('workbenchGroup');
  const watchInstanceType = watch('instance_type');
  const selectedInstance = typesData && typesData[selectedWorkbenchGroup]?.find(({ id }) => id === watchInstanceType);

  return (
    <Grid container spacing={4} p={2} pb={4} sx={modalOverflowBoxStyles}>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlLabel
          required
          label="WORKBENCH NAME"
          control={
            <TextField
              {...register('name')}
              error={!!errors.name}
              helperText={
                (errors.name?.message as string) ||
                'Use up to 255 characters (alphanumeric, whitespaces and + - = . _ : / @)'
              }
              slotProps={{ htmlInput: { maxLength: workbenchNameRules.max } }}
            />
          }
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <FormControlLabel
          required
          label="DESCRIPTION"
          control={
            <TextField
              error={!!errors.description}
              helperText={errors.description?.message as string}
              {...register('description')}
              slotProps={{ htmlInput: { maxLength: MAX_DESCRIPTION_LENGTH } }}
            />
          }
        />
      </Grid>
      <Grid size={{ sm: 4, xs: 12 }}>
        <FormControlLabel
          label="WORKBENCH TEMPLATE"
          control={<TextField disabled defaultValue="EC2-Based Workbenches" />}
        />
      </Grid>
      <Grid size={{ sm: 4, xs: 12 }}>
        <WorkbenchGroupField />
      </Grid>
      <Grid size={{ sm: 4, xs: 12 }}>
        <InstanceTypeField />
      </Grid>
      {watchInstanceType && (
        <Grid size={12}>
          <Card sx={{ padding: '3rem' }}>
            <Typography variant="h4">{selectedInstance?.name}</Typography>
            <Divider sx={{ my: '2rem' }} />
            <Typography sx={{ whiteSpace: 'pre-line' }}>{selectedInstance?.description.replace(/->/g, '')}</Typography>
          </Card>
        </Grid>
      )}
    </Grid>
  );
};

export default CreateWorkbenchForm;
